__turbopack_context__.v({
  "alignLeft": "MostBookedRoutes-module__g-JZUW__alignLeft",
  "card": "MostBookedRoutes-module__g-JZUW__card",
  "cardImage": "MostBookedRoutes-module__g-JZUW__cardImage",
  "dot": "MostBookedRoutes-module__g-JZUW__dot",
  "dotActive": "MostBookedRoutes-module__g-JZUW__dotActive",
  "dots": "MostBookedRoutes-module__g-JZUW__dots",
  "header": "MostBookedRoutes-module__g-JZUW__header",
  "headingBlock": "MostBookedRoutes-module__g-JZUW__headingBlock",
  "imageWrap": "MostBookedRoutes-module__g-JZUW__imageWrap",
  "label": "MostBookedRoutes-module__g-JZUW__label",
  "section": "MostBookedRoutes-module__g-JZUW__section",
  "slickSlide": "MostBookedRoutes-module__g-JZUW__slickSlide",
  "slickWrap": "MostBookedRoutes-module__g-JZUW__slickWrap",
  "slider": "MostBookedRoutes-module__g-JZUW__slider",
});
